import styled from 'styled-components';

export const LoadShadow = styled.span`
  opacity: 1;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease-in;
  background: rgba(240, 240, 240, 0.8);
`;
